module.exports = __webpack_public_path__ + "img/profile-pic.9a2314c3.jpg";